module.exports = __webpack_public_path__ + "4f71765523d66dc8994527b53e463481.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/age-gate-bg-768.webp
// module id = 174
// module chunks = 0